import React from 'react';

export default class PublicButton extends React.Component 
{
    constructor(props)
    {
        super(props);
    }

    static defaultProps = 
    {
        type: "button",
        name: "",
        onClick: function(){}
    };

    render() 
    {
        const props = this.props;

        return (
            <button 
                type={props.type} 
                name={props.name} 
                onClick={props.onClick} 
                className="btn btn-lg btn-primary block full-width m-b mb-0" 
                style={{height: "45px"}}>
                
                {props.children}
            </button>
        )
    }
}
